// Global
import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useWindowSize } from 'usehooks-ts';
import { UpOutlined, DownOutlined } from '@ant-design/icons';


// Local
// @ts-ignore
import Constants from "../../config.js";
// @ts-ignore
import { UserContext } from "../../Contexts/UserContext/UserContext"
// @ts-ignore
import keyToRouteMap from '../../helpers/keyToRouteMap.js'; // TODO not used yet but will be used to retrieve keys from routes
// @ts-ignore
import { ActiveTokenCard } from '../ActiveTokenCard.js';
// @ts-ignore
import { CubeIcon, CubesIcon, SeedlingIcon, PaperPlaneIcon, FireFlameIcon, WalletFireIcon, ShieldIcon } from '../../helpers/svgToIcon.js';
// @ts-ignore
import MenuPanelHeader from '../MenuPanelHeader.js';

import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

// Antd
import {
	HomeFilled,
	ContainerFilled,
	UnorderedListOutlined,
	SwapOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import { Settings, GppMaybe, AccountBalanceWallet } from '@mui/icons-material';

// CSS
import './MenuPanelOptions.module.css';
import { MenuAdminSection } from './MenuAdminSection';
// @ts-ignore
import {SectionProps} from './helpers.js'
// @ts-ignore
import { isTokenScopedPathname } from '../../helpers/useTokenOrigin.js';


// TODO: use this https://usehooks.com/usewindowsize | change mode in mobile view
// TODO: replace every hardcoded string with a proper text table


const MenuWalletSection: React.FC<SectionProps & { }> = ({ selectedKey, onItemSelect }) => {

	const userContext = useContext(UserContext)
	let walletName = "Wallet"
	// @ts-ignore
	if(userContext.walletname) {
		// @ts-ignore
		walletName = userContext.walletname
	}

	return (
	<section id="menuWalletSection" className="menuSection">
		<MenuPanelHeader label="Wallet">
			<div style={{fontWeight:"bold"}}>
		{/* <ContainerOutlined className="sectionIcon" /> */}
		&nbsp; {walletName}
		</div>
		</MenuPanelHeader>
		{/* <div className="sectionHeader">
			&nbsp; <span className="sectionTitle">&nbsp; {walletName}</span>
		</div> */}
		<Menu
			mode="inline"
			theme="dark"
			selectedKeys={selectedKey ? [selectedKey] : []}
			onSelect={({ key }) => onItemSelect?.(key)}
			items={[
				// { key: 'wallet-display-all', label: 'Tokens' },
				// { key: 'wallet-settings', icon: <SettingsOutlined />, label: 'Settings' },
				{ key: '/wallet', icon: <AccountBalanceWallet />, label: 'Tokens' },
				{ key: '/wallet/settings', icon: <Settings />, label: 'Settings' },
			]}
		/>
	</section>
)};

const MenuTokenSection: React.FC<SectionProps & { }> = ({ selectedKey, onItemSelect }) => {
	
	const userContext = useContext(UserContext)
	// @ts-ignore
	const coinProps = userContext.get_selected_coin_props()
	const tokenName = coinProps.name 
	const tokenid = coinProps.tokenid
	const prefix = '/wallet/' + tokenid
	// @ts-ignore
	const isloading = userContext.isloading
	const handleReload = () => {
		if (isloading) return
		if (tokenid === "bsv") {
			// @ts-ignore
			userContext.reload_bsv()
		} else {
			// @ts-ignore
			userContext.reload_token()
		}
	}
	// @ts-ignore
	var itemsList = [
        { key: prefix, icon: <AccountBalanceWallet />, label: 'Balance' }
    ]
    if(tokenid !== "bsv") {
		// @ts-ignore
        itemsList = itemsList.concat({ key: prefix + '/mintuples', icon: <SeedlingIcon />,
			label: 'Mintuples' })
    }
    itemsList = itemsList.concat([
        { key: prefix + '/history', icon: <UnorderedListOutlined />, label: 'History' },
        { key: prefix + '/send', icon: <PaperPlaneIcon />, label: 'Send' },
        { key: prefix + '/swap', icon: <SwapOutlined />, label: 'Buy & Sell' },
    ])

	const reloadButtonStyle: React.CSSProperties = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '8px',
		width: '100%',
		padding: '8px 16px',
		marginTop: '8px',
		backgroundColor: isloading ? '#1a2a3a' : '#001432',
		color: isloading ? '#666' : '#00E8D1',
		border: '1px solid #2a3a4a',
		borderRadius: '6px',
		cursor: isloading ? 'not-allowed' : 'pointer',
		fontFamily: 'Roboto, sans-serif',
		fontSize: '14px',
	}

	return (
		<section id="menuTokenSection" className="menuSection">
			<ActiveTokenCard onClick={() => onItemSelect?.(prefix)}/>
			<Menu
				mode="inline"
				theme="dark"
				selectedKeys={selectedKey ? [selectedKey] : []}
				onSelect={({ key }) => onItemSelect?.(key)}
				items={itemsList}
			/>
			<button onClick={handleReload} style={reloadButtonStyle} disabled={isloading}>
				<i className={"fas fa-sync " + (isloading ? "fa-spin" : "")} />
				Refresh
			</button>
		</section>
	)
};

const MenuPanelOptions: React.FC<{ onClose: () => void }> = (props) => {
	const history = useHistory();
	const [selectedKey, setSelectedKey] = useState<string | null>(null);
	const [isTokenPickerHome, setIsTokenPickerHome] = useState<boolean>(false);

	const location = useLocation();
  	useEffect(() => {
		const path = location.pathname;
		// Menu item keys are the route pathnames themselves (e.g. /wallet/delphe/history),
		// so the active key is just the current pathname. Home maps to the "Tokens" entry.
		const key = (path === '/' || path === '/home') ? '/wallet' : path;
    	setSelectedKey(key);
		// Hide the token-scoped sections where no token is loaded:
		// the token picker home and Settings.
		setIsTokenPickerHome(!isTokenScopedPathname(path));
    	console.log(`URL changed, selectedKey updated to: ${key} (path was ${path})`);
  	}, [location.pathname]);

	  const { width: windowWidth = 0 } = useWindowSize(); // fallback
	  const isMobile = windowWidth < Constants.WINDOW_WIDTH_THRESHOLD_PX
	  console.log("App.js: isMobile=", isMobile)

	const handleItemSelect = (key: string) => {
		setSelectedKey(key);
		console.log(`Selected item: ${key}`);
		// const keyToRouteMapDict = keyToRouteMap()
		if (key) {
			history.push(key);
		}
		if(isMobile){
			props.onClose() // close menu
		}
	};
	
    const userContext = useContext(UserContext)
	// @ts-ignore
	const ownerIsAdmin = userContext.ownerIsAdmin
	// @ts-ignore
	const coinProps = userContext.get_selected_coin_props()
	const tokenid = coinProps.tokenid

	return (
		<div className={"menuSectionContainer" + (isMobile? " menuSectionContainerMobile":"")}>

			<div style={{height:"14px"}}/>  {/* spacer */}

			<MenuWalletSection 
				selectedKey={selectedKey}
				onItemSelect={handleItemSelect}
			 />
			 <br/>
			
			{isTokenPickerHome ? null : <>
			<MenuTokenSection
				selectedKey={selectedKey}
				onItemSelect={handleItemSelect}
			/>

			{tokenid==="bsv"?null:<>
				{ownerIsAdmin ? <>
					<MenuAdminSection
						selectedKey={selectedKey}
						onItemSelect={handleItemSelect}
					/>
				</> : null}
			</>}
			</>}
		</div>
	);
};

export default MenuPanelOptions;
